export class LoadImageCompressionSettingsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "LoadImageCompressionSettingsError";
  }
}
